








import Vue from 'vue';
import Component from 'vue-class-component';
import {GraphTab} from "../core/interface";

@Component({
    props: [
        'tabs',
        'currentTab'
    ]
})
export default class Tabs extends Vue {
    currentTab: GraphTab;
    tabs: GraphTab[];

    public onTabChange(path: string): void {
        this.$emit('onTabChanged', path);
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/tabs.vue